import { MantineThemeOverride } from '@mantine/core'

export const fontSizes: MantineThemeOverride['fontSizes'] = {
    xs: '1.2rem',
    sm: '1.4rem',
    md: '1.6rem',
    lg: '1.8rem',
    xl: '2rem'
}

const spacing: MantineThemeOverride['spacing'] = {
    none: '0',
    xxs: '0.2rem',
    xs: '0.4rem',
    sm: '0.8rem',
    md: '1.2rem',
    lg: '1.6rem',
    xl: '2.4rem',
    xxl: '3.2rem'
}

const radius: MantineThemeOverride['radius'] = {
    none: '0',
    xs: '0.2rem',
    sm: '0.4rem',
    md: '0.8rem',
    lg: '1.6rem',
    xl: '2.4rem',
    xxl: '3.2rem'
}

export default {
    fontSizes,
    spacing,
    radius
} as MantineThemeOverride
